import React, { useEffect, useState } from 'react';
import DashboardCard from './DashboardCard';
import RadarChart from './RadarChart';

import {
  useGetAssessmentPeriodMetricResultsQuery,
} from 'areas/assessment-schedule/api';
import { useNavigate } from 'react-router';
interface DashboardPillarRadarProps {
  assessment_period_id: number;
  prior_assessment_period_id: number;
}

const DashboardPillarRadar = ({
  assessment_period_id,
  prior_assessment_period_id,
}: DashboardPillarRadarProps) => {
  const { data: firstData } = useGetAssessmentPeriodMetricResultsQuery(
    { assessmentPeriodId: assessment_period_id },
    { skip: !assessment_period_id }
  );

  const { data: secondData } = useGetAssessmentPeriodMetricResultsQuery(
    { assessmentPeriodId: prior_assessment_period_id },
    { skip: prior_assessment_period_id === null }
  );

  const [firstPillarScores, setFirstPillarScores] = useState<{ label: string; value: number }[]>([]);
  const [secondPillarScores, setSecondPillarScores] = useState<{ label: string; value: number }[]>([]);
  const [firstDataName, setFirstDataName] = useState('');
  const [secondDataName, setSecondDataName] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (firstData?.pillars?.length) {
      const factorScoreData = firstData.pillars;
      const scores = factorScoreData.map((item: { label: string; average_response: number }) => ({
        label: item.label,
        value: parseFloat(item.average_response.toFixed(1)),
      }));
      setFirstPillarScores(scores);
      setFirstDataName(firstData.assessment_period_name || '');
      return;
    }

    setFirstPillarScores([]);
    setFirstDataName('');
  }, [firstData]);

  useEffect(() => {
    if (secondData?.pillars?.length) {
      const factorScoreData = secondData.pillars;
      const scores = factorScoreData.map((item: { label: string; average_response: number }) => ({
        label: item.label,
        value: parseFloat(item.average_response.toFixed(1)),
      }));
      setSecondPillarScores(scores);
      setSecondDataName(secondData.assessment_period_name || '');
      return;
    }

    setSecondPillarScores([]);
    setSecondDataName('');
  }, [secondData]);

  return (
    <DashboardCard title="Pillar Radar" titleMargin="0" onClick={() => navigate('/app/analytics')}>
      <div style={{ width: '100%', height: '100%' }}>
        <RadarChart
          data1={firstPillarScores}
          data2={secondPillarScores}
          label1={firstDataName}
          label2={secondDataName}
        />
      </div>
    </DashboardCard>
  );
};

export default DashboardPillarRadar;

